var map = {
	"./aqua1.png": "8bc3",
	"./blue1.png": "79f7",
	"./indigo1.png": "8b1f",
	"./maroon1.png": "2325",
	"./orange1.png": "2baa",
	"./pink1.png": "439c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3434";